module.exports = __webpack_public_path__ + "media/images/icons/search-fat-8549b6b21120ea6b50852e520c652a6e.svg";